import { Link } from 'react-router';
import { BRAND, brandName } from '@/brand/brand';
import { Logo } from '@/brand/Logo';
import { MasjidSkyline } from '@/components/Masjid';
import { Screen } from '@/components/Screen';
import { useAppState } from '@/state/useAppState';
import { useT } from '@/state/useT';

export function Welcome() {
  const { skin, times, now } = useAppState();
  const { t, locale } = useT();

  return (
    <Screen
      centre
      foot={
        <>
          <Link
            to="/onboarding"
            className="btn-p"
            style={{ display: 'grid', placeItems: 'center' }}
          >
            {t(skin === 'kids' ? 'welcome.start.kids' : 'welcome.start.adult')}
          </Link>
          <div className="muted-note" style={{ textAlign: 'center' }}>
            {t('welcome.privacy')}
          </div>
        </>
      }
    >
      <MasjidSkyline className="welcome-horizon" />
      <div className="centre-column">
        {/* The mark itself, hanging as an astrolabe is used — and reading
            today's real times against the real minute, so the first thing
            anyone sees is the day they are actually in. */}
        <div className="bob">
          <Logo size={148} times={times} now={now} hanging />
        </div>
        <div className="wordmark" style={{ marginTop: 22 }}>
          {brandName(locale)}
        </div>
        {BRAND.provisional ? (
          <div className="muted-note" style={{ marginTop: 6, fontSize: 11 }}>
            {t('app.provisionalName')}
          </div>
        ) : null}
        <div
          style={{
            fontFamily: 'var(--fd)',
            fontSize: 19,
            fontWeight: 700,
            lineHeight: 1.35,
            marginTop: 18,
          }}
        >
          {t('app.tagline')}
        </div>
        <div className="muted-note" style={{ marginTop: 10, maxWidth: 280, fontSize: 13 }}>
          {t('app.blurb')}
        </div>
      </div>
    </Screen>
  );
}
